import { Component, OnInit } from '@angular/core';
import { LoaderHandlerService } from '../loader-handler.service';
import { UtilityService } from 'src/app/core/services/UtilityService/UtilitiesService';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-spinner-helper',
  templateUrl: './spinner-helper.component.html',
  styleUrls: ['./spinner-helper.component.scss']
})
export class SpinnerHelperComponent implements OnInit {

  spinnerActive: boolean = true;

  constructor(
    public spinnerHandler: LoaderHandlerService,
    private _utilityService: UtilityService,
    private spinner: NgxSpinnerService,
  ) { 
    // whenever the value changes that is whether true or false the spinner should come up
    this.spinnerHandler.showSpinner.subscribe(this.showSpinner.bind(this));
  }

  ngOnInit(): void {
  }

  //  // Show spinner
   ShowSpinner() {
    this._utilityService.ShowSpinner()
    // this.spinner.show();
  }

  // // Hide spinner
  HideSpinner() {
    this._utilityService.HideSpinner();
    // this.spinner.hide();
  }

  showSpinner = (state: boolean): void => {
    if (state) {
      this.ShowSpinner()
      // this._utilityService.ShowSpinner()
      // this.spinner.show();
    } else {
      this.HideSpinner()
      // this._utilityService.HideSpinner();
      // this.spinner.hide();
      // this.spinner.show()
    }
    this.spinnerActive = state;
  };
}
